import type { QueryClient } from '@tanstack/react-query'
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router'
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools'
import { ToastViewport } from '@/shared/ui/toast'

interface RouterContext {
  queryClient: QueryClient
}

// Корень bare: AppShell живёт на layout-роуте _app — публичные страницы
// (login, booking) рендерятся без каркаса.
export const Route = createRootRouteWithContext<RouterContext>()({
  component: () => (
    <>
      <Outlet />
      <ToastViewport />
      {import.meta.env.DEV && <TanStackRouterDevtools position="bottom-right" />}
    </>
  ),
})
